import { IServiceResponse } from "@/core/model/rest/IServiceResponse";
import BaseService from "../base/BaseService";
import IParamServices from "../IParamServices";

export default class ParameterService extends BaseService
{
    constructor(param: IParamServices)
    {
        super(param);
    }
    public async CargaInicial()
    {
      let response:IServiceResponse|null = null;
      response = await this.Get('IndexParameters/CargaInicial' ,null,null,null,true,false,null);
      return response;
    }
    public async SendExampleEmail()
    {
      let response:IServiceResponse|null = null;
      response = await this.Get('IndexParameters/SendExampleEmail' ,null,null,null,true,false,null);
      return response;
    }
}